/**
 * Identity key for reconciling chat messages across sources — an optimistic
 * send, the GET /chat payload (raw SQL), and the websocket echo of the same
 * message. The client mints `ts` (epoch ms) at send time and the server stores
 * it, so `userId:ts` is the stable cross-source key; `ts` alone would collapse
 * two users sending in the same millisecond. `String(ts)` because the DB
 * serializes the bigint column as a string while optimistic copies carry a
 * number. Falls back to the row id for messages without a `ts` (pre-`ts` rows,
 * server-generated messages).
 */
export const chatDedupeKey = (chat: {
  ts?: number | string | null;
  id?: string;
  userId?: string | null;
}): string => (chat?.ts ? `${chat.userId ?? ""}:${chat.ts}` : (chat?.id ?? ""));
